import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";

import {
  HvButton,
  HvInput,
  HvDropdown,
} from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";

import { useIncidentTypes } from "lib/api";
import useStyles from "./styles";

interface SopTableControls {
  onSearch: (value: string) => void;
  onFilter: (value: string[]) => void;
}

interface Filter {
  id: string;
  name: string;
  label: string;
}

const SopTableControls: React.FC<SopTableControls> = ({
  onSearch,
  onFilter,
}) => {
  const { t } = useTranslation("common");
  const { t: sopT } = useTranslation("sop");
  const history = useHistory();
  const { url } = useRouteMatch();
  const classes = useStyles();

  const { data: incidentTypesData } = useIncidentTypes(undefined, {
    revalidateOnFocus: false,
  });

  const incidentTypeDataFilter =
    incidentTypesData?.data.map((incidentType) => ({
      id: String(incidentType.pk_inc_type_id),
      name: incidentType.inc_type_name,
      label: incidentType.inc_type_name,
    })) || [];

  const [filters, setFilters] = useState<Filter[]>(incidentTypeDataFilter);

  const onChangeHandler = (value: Filter[]) => {
    const selectedIds = value.map((val) => val.id);
    setFilters(
      incidentTypeDataFilter.map((val) => ({
        ...val,
        selected: selectedIds.includes(val.id),
      }))
    );
    onFilter(selectedIds);
  };

  return (
    <div className={classes.root}>
      <HvInput
        className={classes.inputPlaceholder}
        aria-label={t("common:search.ariaLabel")}
        placeholder={t("common:search.placeholder")}
        type="search"
        onEnter={(event, value) => onSearch?.(value)}
      />
      <HvDropdown
        multiSelect
        showSearch={incidentTypeDataFilter.length > 10}
        values={filters}
        onChange={(value) => onChangeHandler(value as [])}
        className={classes.filter}
        {...(incidentTypeDataFilter.length > 10 && {
          classes: {
            dropdownListContainer: classes.filterDropdownListContainer,
          },
        })}
        hasTooltips
        label={sopT("sop:labels.incidentType")}
      />
      <HvButton
        className={classes.add}
        category="semantic"
        startIcon={<Add />}
        onClick={() => history.push(`${url}/add`)}
      >
        {t("common:buttons.add")}
      </HvButton>
    </div>
  );
};

export default SopTableControls;
